import type { Uuid } from "@vesta/common-type-definitions/typeDefinitions";
import { uuidZodValidator } from "@vesta/global-common-typescript/validators/zodValidators";
import { z as zod } from "zod";

export type TuffexProductCatalogueWorkspaceCapabilityConfiguration = {
    catalogueTemplates: Record<Uuid, {
        configuration: Record<string, unknown>;
        parentId: Uuid | null;
        parentColumnId: Uuid;
        statusColumnId: Uuid;
        deleted: boolean;
    }>;
};

export const tuffexProductCatalogueWorkspaceCapabilityConfigurationValidator = zod.strictObject({
    catalogueTemplates: zod.record(
        uuidZodValidator,
        zod.strictObject({
            configuration: zod.record(zod.string(), zod.unknown()),
            parentId: uuidZodValidator.nullable(),
            parentColumnId: uuidZodValidator,
            statusColumnId: uuidZodValidator,
            deleted: zod.boolean(),
        }),
    ),
}) satisfies zod.ZodType<TuffexProductCatalogueWorkspaceCapabilityConfiguration>;
